module.exports = __webpack_public_path__ + "static/media/point_trophy.25876fdc.png";